import { defineMessages } from "react-intl";

export const scope = "components.DepositOmnibusAccount";

export const messages = defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: "Tu alias",
  },
  transferOrigin: {
    id: `${scope}.transferOrigin`,
    defaultMessage: "Origen de la transferencia",
  },
  eeuu: {
    id: `${scope}.eeuu`,
    defaultMessage: "Estados Unidos (ACH o Wire)",
  },
  swift: {
    id: `${scope}.swift`,
    defaultMessage: "Resto del mundo (SWIFT)",
  },
  currencyToReceive: {
    id: `${scope}.currencyToReceive`,
    defaultMessage: "Moneda a recibir",
  },
  copy: {
    id: `${scope}.copy`,
    defaultMessage: "COPIAR",
  },
  monthlyDeposits: {
    id: `${scope}.monthlyDeposits`,
    defaultMessage:
      "Todos tus depósitos no podrán superar los { amount } { currency } mensuales.",
  },
});
